import React, { useEffect, useReducer, useState } from 'react';
import GeneralButton from '../components/helpers/GeneralButton';
import GeneralButtonWithText from '../components/helpers/GeneralButtonWithText';
import ConfirmAlert from '../components/ui/ConfirmAlert';
import Tools from '../cvp-webgames-core/Misc/Tools';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import { globals } from '../misc/globals';
import { ScenariosConfig, SingleScenarioConfig } from '../misc/interfaces';
import { getSaveData, mapDivEnterToClick, saveGame, setFocus, setUp508 } from '../misc/tools';
import Scenario1 from '../scenarios/scenario1/Scenario1';
import BadgeConfig from '../shared/BadgeConfig';
import { Windows } from './MainPage';

export enum Window508Type {
    Main,
    ResetGame,
}

var current508Window = Window508Type.Main;
var windows508Layers: any[] = []

const objectWindowIDs = {
    main: {
        objects: [
            'main-first-object',
            'main-last-object'
        ]
    },
	resetGame: {
        objects: [
            'confirm-alert-first-object',
            'confirm-alert-last-object'
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[Window508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };

    windows508Layers[Window508Type.ResetGame] = {
        objects: objectWindowIDs.resetGame.objects
    };
}

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

const set508Window = (window: Window508Type) => {
    current508Window = window;
    setFocus(getCurrent508WindowLayer().objects[0]);
}

set508Window(Window508Type.Main);

var canPlaySound = true;
var alreadyStated = false;
var sm: ReactSoundManager = null;

var isMuted = false;

const MainMenuPage = (props: any) => {
	const [avatarImg, setAvatarImg] = useState(-1);
	const [isMuted, setIsMuted] = useState(false);
	const [hasStarted, setHasStarted] = useState(false);
	const [showResetDataModal, setShowResetDataModal] = useState(false);
	const [enableDebugMenu, setEnableDebugMenu] = useState(window.location.hostname === 'localhost');
	const [forceUpdate, setForceUpdate] = useState(false);

	const saveData = getSaveData();

	useEffect(() => {
		canPlaySound = true;
		if(initialized) {
			return;
		}

		if(hasStarted && !alreadyStated) {
			sm = new ReactSoundManager();

			const play = () => {
				sm.playSound({
					src: './assets/audio/MainMenuBg.mp3',
					autoPlay: true,
					controls: false,
					enableClosedCaptioning: false,
					muted: false,
					playsInline: true,
					onEnded: () => {
						if(canPlaySound) {
							play();
						}
					}
				})  
			}

			play();
			alreadyStated = true;
		}
		
		startDebugTimeout();
		initialized = true;
		return () => {
			canPlaySound = false;
		}
	})


	if(avatarImg === -1) {
		setAvatarImg(saveData.avatarIndx);
		return;
	}
	
	var initialized = false;

	var debugTimeout: any = undefined;

	var startDebugTimeout = () => {
		if(debugTimeout) {
			clearTimeout(debugTimeout);
			debugTimeout = undefined;
		}

		(window as any).gameDebug = enableDebugMenu;

		debugTimeout = setTimeout(() => {
			if(window && (window as any)['gameDebug'] !== enableDebugMenu) {
				setEnableDebugMenu((window as any)['gameDebug']);
			}
			startDebugTimeout();
		}, 3000);
	};

	
	const setAvatarSelection = (indx: number) => {
		if(indx < 0) {
			indx = 3;
		} else if (indx > 3) {
			indx = 0;
		}

		saveData.avatarIndx = indx;
		saveGame(saveData);

		setAvatarImg(indx);
	}

	return (
		<div style={{
			position: 'relative',
			pointerEvents: 'all',
			width: '100%',
    		height: '100%'
		}}>
			<img style={{
				position: 'absolute',
				maxWidth: 'none',
    			width: '100%'
			}} src="./assets/images/main-menu/main-menu-bg.jpg"/>

			{hasStarted ? (
				<div>
					<div  style={{
						width: '5%',
						position: 'absolute',
						top: '17%',
						left: '1%',
						cursor: 'pointer',
						zIndex: 10,
						pointerEvents: 'all'
					}}
					aria-label="Toggle Mute"
					role="button"
					id='main-last-object'
					tabIndex={0}
					onKeyUp={mapDivEnterToClick}
					onClick={() => {
						sm.mutedAudio = !isMuted;
						setIsMuted(!isMuted);
					}}>
						<img className="pointer" src={isMuted ? './assets/images/audioOff.svg' : './assets/images/audioOn.svg'} />
					</div>

					<div>
						<img style={{
							position: 'absolute',
							border: '7px solid #999',
							top: '90px',
							left: '190px',
							width: '290px'
						}} src={"./assets/images/main-menu/avatars/a" + avatarImg  + ".png"}/>

						<GeneralButton parameters= {{
							srcIdle: './assets/images/main-menu/button_avatarpresets_back_main.png',
							srcHighlight: './assets/images/main-menu/button_avatarpresets_back_down.png',
							ariaLbl: 'Previous Avatar Preset',
							id: 'first-button',
							top: '972px',
							left: '169px',
							width: '75.33px',
							highlightOnHover: true,
							onClicked: () => {
								setAvatarSelection(avatarImg-1);
							}
						}}/>

						<p className="regular-description-font" style={{
							position: 'absolute',
							top: '972px',
							left: '236px',
							width: '191px',
							textAlign: 'center',
							margin: '0',
							fontSize: '22pt',
							color: 'rgb(204,204,229)'
						}}>Avatar Presets</p>

						<GeneralButton parameters= {{
							srcIdle: './assets/images/main-menu/button_avatarpresets_next_main.png',
							srcHighlight: './assets/images/main-menu/button_avatarpresets_next_down.png',
							ariaLbl: 'Next Avatar Preset',
							top: '972px',
							left: '421px',
							width: '75.33px',
							highlightOnHover: true,
							onClicked: () => {
								setAvatarSelection(avatarImg+1);
							}
						}}/>
					</div>

					<div style={{
						position: 'absolute',
						right: '80px',
						top: '50%',
						width: '890px',
						transform: 'translate(0, -50%)'
					}} tabIndex={0} id={objectWindowIDs.main.objects[0]} aria-label='Main Menu. Choose a level'>
						<img style={{
						}} src="./assets/images/main-menu/Container.png"/>
						<p className="regular-description-font" style={{
							position: 'absolute',
							top: '13px',
							left: '43px',
							margin: '0',
							width: '217px',
							textAlign: 'center'
						}}>HOME</p>

						<div style={{
							position: 'absolute',
							top: '-1px',
							left: '321px',
							width: '470px',
							display: saveData.scenarios[4].isUnlocked ? 'block' : 'none'
						}}>
							<GeneralButton parameters= {{
								ariaLbl: 'Summative Level',
								srcIdle: './assets/images/main-menu/summative_button.png',
								srcHighlight: './assets/images/main-menu/summative_highlight.png',
								top: '0px',
								left: '-23px',
								width: '600px',
								highlightOnHover: true,
								customImageStyle: {
									height: '52px'
								},
								onClicked: () => {
									canPlaySound = false;
									props.updateWindow(Windows.Level5);
								}
							}}/>
							<p className="regular-description-font" style={{
								position: 'absolute',
								top: '13px',
								margin: '0',
								left: '-14px',
								width: '583px',
								textAlign: 'center',
								pointerEvents: 'none'
							}}>SUMMATIVE</p>
						</div>
						<div style={{
							position: 'absolute',
							top: '75px',
							left: '50px',
							width: '800px',
							height: '700px',
							display: 'grid',
							gridTemplateColumns: 'auto auto'
						}}>
							{saveData.scenarios.map((s: SingleScenarioConfig, indx: number) => {
								if(indx === 4) {
									//summative is ignored
									return (null);
								}

								var isEnabled = () => {
									return s.isUnlocked;
								}

								var updatehighlight: any = null;
								var onClicked = () => {
									if(!isEnabled()) {
										return;
									}
									canPlaySound = false;
									props.updateWindow(indx + 2); //+2 because 0 = nothing and 1 = main menu...2 = level 1
								};
								
								return (
									<div key={Tools.generateGuid()} style={{
										position: 'relative',
										margin: '10px',
										pointerEvents: s.isUnlocked ? 'all' : 'none'
									}} className="pointer" 
									aria-disabled={!isEnabled()}
									onClick={onClicked}
									tabIndex={isEnabled() ? 0 : -1}
									onKeyUp={mapDivEnterToClick}
									aria-label={
										(() => {
											var unlockedBadges = s.badges.filter(b => b.isUnlocked);
											return s.scenarioName + '. ' + unlockedBadges.length + ' out of ' + s.badges.length + ' badges unlocked';
										})()
									}
									onMouseOver={() => {
										updatehighlight(true)
									}}
									onMouseOut={() => {
										updatehighlight(false)
									}}>
										<div style={{
											position: 'absolute',
											zIndex: 1
										}}>
											<GeneralButton parameters= {{
												NotTabbable: true,
												srcIdle: './assets/images/main-menu/button_badging_play_main.png',
												srcHighlight: './assets/images/main-menu/button_badging_play_down.png',
												srcDisabled: './assets/images/main-menu/button_badging_play_disabled.png',
												isDisabled: !s.isUnlocked,
												onForceHighlight: (forceHighlight: (shouldForce: boolean) => void) => {
													updatehighlight = forceHighlight;
												},
												top: '0',
												left: '0',
												width: '95.33px',
												highlightOnHover: true,
												onClicked: onClicked
											}}/>
										</div>
										
										<p className="regular-description-font" style={{
											position: 'absolute',
											top: '33px',
											left: '76px',
											margin: '0px',
											width: '267px',
											textAlign: 'center'
										}}>Click to Play</p>

										<div style={{
											position: 'absolute',
											top: '72px',
											left: '47px',
											width: '280px',
											height: '139px',
											display: 'grid',
											pointerEvents: 'none',
											gridTemplateColumns: s.badges.length % 3 === 0 ? 'auto auto auto' : 'auto auto'
										}}>
											{s.badges.map((b: BadgeConfig, bIndx: number) => {
												return (
													<img style={{
														width: '100px',
														position: 'relative',
														left: s.badges.length % 3 !== 0 && bIndx % 2 === 0 ? '37px' : '0' 
													}} src={b.isUnlocked ? b.unlockedImage : b.lockedImage}/>
												)
											})}
										</div>


										<p className="regular-description-font" style={{
											position: 'absolute',
											top: '276px',
											left: '77px',
											margin: '0px',
											width: '216px',
											textAlign: 'center'
										}}>{s.scenarioName}</p>
										<img style={{
											position: 'absolute',
											top: '18px',
											left: '16px',
											zIndex: -1,
											width: '90%'
										}} src={"./assets/images/main-menu/window_badging.png"}/>

										{s.isUnlocked ? (null) : 
										(<img style={{
											position: 'absolute',
											top: '18px',
											left: '16px',
											width: '90%',
											opacity: 0.4
										}} src={"./assets/images/main-menu/window_badging_disabled.png"}/>)}
										
									</div>
								)
							})}
						</div>
					</div>
					
					<GeneralButtonWithText parameters= {{
						id:objectWindowIDs.main.objects[1],
						text: 'Reset Game',
						top: '972px',
						left: '1645px',
						width: '215px',
						onClicked: () => {
							set508Window(Window508Type.ResetGame);
							setShowResetDataModal(true);
						}
					}}/>
					{showResetDataModal ? <ConfirmAlert id={Tools.generateGuid()} key={Tools.generateGuid()} dispatch={null} parameters= {{
						onYes: () => {
							localStorage.clear();
							window.location.reload();
						},
						onNo: () => {
							set508Window(Window508Type.Main);
							setShowResetDataModal(false);
						},
						text: 'Are you sure you want to reset your game? Everything that has been accomplished in the game will be deleted and you will have to start from the very beginning of level 1.',

					}}></ConfirmAlert>
						: (null)}
				</div>
			) : (
				<div>
					<button style={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						width: '300px',
						height: '90px',
						color: 'white',
						fontSize: '30px',
						backgroundColor: 'steelblue',
						border: '10px solid',
						borderColor: 'rgb(159 159 159)',
						transform: 'translate(-50%, -50%)'
					}} onMouseEnter={() => {
						var rollOverAudio = document.getElementById('button-rollover');
						
						if(!globals.isMuted) {
							(rollOverAudio as any).play();
						}
					}} onClick={() => {
						var clickAudio = document.getElementById('button-click');
						if(!globals.isMuted) {
							(clickAudio as any).play();
						}
						setHasStarted(true);
					}}>Click Here To Start</button>
				</div>
			)}

			{enableDebugMenu ? (
				// <button tabIndex={-1} style={{
				// 	position: 'absolute',
				// 	bottom: '10px',
				// 	left: '10px',
				// 	color: 'white',
				// 	pointerEvents: 'all',
				// 	zIndex: 100
				// }} onClick={() => {
				// 	globals.showDebugForComponents = !globals.showDebugForComponents;
				// 	setForceUpdate(!forceUpdate);
				// }}>
				// 	{(globals.showDebugForComponents ? 'Hide' : 'Show') + ' Debug Tools'}
				// </button>
				null
			) : (null)}

			{globals.showDebugForComponents ? (
					<button tabIndex={-1} style={{
						position: 'absolute',
						top: '10px',
						left: '50%',
						transform: 'translate (-50%, 0)',
						color: 'white',
						pointerEvents: 'all',
						zIndex: 100
					}} onClick={() => {	
						for(var indx = 0; indx < saveData.scenarios.length; indx++) {
							saveData.scenarios[indx].isUnlocked = true;
						}

						saveGame(saveData);
						setForceUpdate(!forceUpdate);
					}}>
						Unlock All levels
					</button>
				) : (null)}

			<audio id='button-click' src="./assets/audio/Default_ButtonClick.mp3" playsInline={true} controls={false} muted={isMuted}></audio>
			<audio id='button-rollover' src="./assets/audio/Default_ButtonRollover.mp3" playsInline={true} controls={false} muted={isMuted}></audio>
		</div>
	);
};

export default MainMenuPage;
